<template>
    <v-flex>
        <v-btn v-on:click="resend"><v-icon>send</v-icon> Resend</v-btn>
    </v-flex>
</template>

<script>
/**
 * Triggers a request to the server to resend this channel message
 */
export default {
    name: 'ies-resend-failed-channel',
    props: ['field', 'value'],
    data () {
        return {
        }
    },

    methods: {
        resend: function(event){
            this.preventParentBehaviour(event);

            var url = "/api/channels/message/resend-failed?id=" + this.value;
            axios.get(url)
            .then(function(response){
                console.log(response);
                alert("Done");
            }.bind(this));
        },

        /**
         * Attempt to prevent default behaviours in parent components
         */
        preventParentBehaviour: function(e){
            console.log(e);
            //e.preventDefault();
            e.stopPropagation();    
        }

    }
}
</script>
